var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var S3ParquetImportConfig_1;
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { FlatFileImportConfig } from './flatFileImportConfig';
import { ImportConfigType } from './importConfig';
import { s3ParquetImportConfigSchemaValidation } from '../../validations.generated';
export const s3ParquetImportConfigSchema = {
    $id: 'urn:wisepipe-common-data:S3ParquetImportConfig',
    type: 'object'
};
// Used for special external s3 parquet where the external s3 import is read directly
// in the python calc file
let S3ParquetImportConfig = S3ParquetImportConfig_1 = class S3ParquetImportConfig extends FlatFileImportConfig {
    constructor(s3File, columnsToUpdate) {
        super(ImportConfigType.S3Parquet, s3File, columnsToUpdate);
        JSON.validate(this, S3ParquetImportConfig_1);
    }
    get supportedRefreshOperations() {
        return [];
    }
    get needsDiscovery() {
        return false;
    }
    get isParquetImport() {
        // this is special; this import should not go through importservice or singer
        // and should instead be only used in transient calcs
        // this property is used only in import+singer, but set it to false just in case
        return false;
    }
};
S3ParquetImportConfig = S3ParquetImportConfig_1 = __decorate([
    JsonSchemaV2(s3ParquetImportConfigSchema, s3ParquetImportConfigSchemaValidation),
    JsonDiscriminatorValue(ImportConfigType.S3Parquet)
], S3ParquetImportConfig);
export { S3ParquetImportConfig };
//# sourceMappingURL=s3ParquetImportConfig.js.map